import React from 'react';
import { Helmet } from 'react-helmet-async';

export function SEO({ title, description, path = "" }) {
  const isHome = !title || title === "Altmuligmanden Juelsminde" || title === "Forside";
  
  const pageTitle = isHome 
    ? "Altmuligmanden Juelsminde" 
    : `${title} - Altmuligmanden Juelsminde`;

  const defaultDescription = "Din lokale altmuligmand i Juelsminde til reparationer, montering, maling, havearbejde, flytning, rydning og praktisk vedligeholdelse.";
  const metaDescription = description || defaultDescription;

  const canonicalUrl = `https://altmuligmanden-juelsminde.dk${path}`;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
}
